function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
class ErrorBoundary extends React.Component {
    componentDidCatch(error, info) {
        const { onError } = this.props;
        this.setState({
            hasError: true,
            error,
            info
        });
        onError(error, info);
    }
    render() {
        const { hasError, error, info } = this.state;
        const { errorView: ErrorView, children } = this.props;
        if (hasError && error && info) {
            return /*#__PURE__*/ _jsx(ErrorView, {
                error: error,
                info: info
            });
        }
        return children;
    }
    constructor(...args){
        super(...args);
        _define_property(this, "state", {
            hasError: false,
            error: null,
            info: null
        });
    }
}
export { ErrorBoundary as default };

//# sourceMappingURL=ErrorBoundary.js.map